import { isEqual } from "lodash-es";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { generateAlgoliaParameters } from "@/redux/modules/value/search/search.actions";
import { getAlgoliaParameters } from "@/redux/modules/value/search/search.selectors";
import { AlgoliaParameters } from "@/redux/modules/value/search/search.types";
import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";

const areParametersValid = (
    parameters?: AlgoliaParameters
): parameters is AlgoliaParameters =>
    !!parameters?.appId && !!parameters?.searchApiKey;

const useAlgoliaParameters = () => {
    const dispatch = useThunkDispatch();
    const algoliaParameters = useSelector(getAlgoliaParameters, isEqual);
    const sessionsAlgoliaParameters =
        AlgoliaUserService.getSessionsStorageSearchParameters();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (areParametersValid(algoliaParameters)) return;
        if (AlgoliaUserService.searchParametersPending()) return;

        dispatch(generateAlgoliaParameters());
    }, [algoliaParameters]);

    return areParametersValid(algoliaParameters)
        ? algoliaParameters
        : areParametersValid(sessionsAlgoliaParameters)
          ? sessionsAlgoliaParameters
          : {};
};

export { useAlgoliaParameters };
